<template>
	<el-select v-model="users" size="large" placeholder="Select people" value-key="id" style="width: 100%;" :multiple="multiple" @change="onChangeOption">
		<el-option-group label="Staff">
			<el-option v-if="user.type == 'Staff'" v-for="user in $store.state.users" :value="user" :label="userName(user)" :key="user.id">{{ userName(user) }}</el-option>
		</el-option-group>
		<el-option-group label="Contractors">
			<el-option v-if="user.type == 'Contractor'" v-for="user in $store.state.users" :value="user" :label="userName(user)" :key="user.id">{{ userName(user) }}</el-option>
		</el-option-group>
		<el-option-group label="Clients">
			<el-option v-if="user.type == 'Client'" v-for="user in $store.state.users" :value="user" :label="userName(user)" :key="user.id">{{ userName(user) }}</el-option>
		</el-option-group>
	</el-select>
</template>

<script>
	
	export default {
		
		props: {
			value: { type: Array },
			multiple: { default() { return true; } },
		},
		
		methods: {
			
			onChangeOption() {
				this.$emit("input", this.users);
				this.$emit("change", this.users);
			},
			
			userName(user) {
				if (user.role) {
					return user.name + " (" + user.role + ")";
				}
				return user.name;
			}
			
		},
		
		watch: {
			value(newValue) {
				this.users = newValue;
			}
		},
		
		data() {
			return {
				users: this.value,
			};
		},
		
	}
	
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/Users/Dropdown.vue